import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ss_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("ss_token", token);
  else localStorage.removeItem("ss_token");
}

export function inr(n) {
  return `₹${Number(n || 0).toLocaleString("en-IN")}`;
}

export async function uploadFiles(fileList) {
  const fd = new FormData();
  Array.from(fileList).forEach((f) => fd.append("files", f));
  const { data } = await api.post("/vendor/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  const base = process.env.REACT_APP_BACKEND_URL;
  return data.urls.map((u) => (u.startsWith("http") ? u : `${base}${u}`));
}

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
